<template>
  <div class="about">
    <v-btn @click="getAllData">Refetch Data</v-btn>
    <v-card class="mx-auto my-10">
      <v-card-title>
        Surveys
        <v-spacer></v-spacer>

        <v-btn icon @click="show = !show">
          <v-icon>{{ show ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
        </v-btn>
      </v-card-title>
      <v-expand-transition>
        <div v-show="show">
          <v-divider></v-divider>

          <v-card-text>
            <highcharts :options="chartOptions"></highcharts>
          </v-card-text>
        </div>
      </v-expand-transition>
    </v-card>

    <v-card class="mx-auto">
      <v-card-title>
        MVP {{ new Date().getFullYear() }}
        <v-spacer></v-spacer>

        <v-btn icon @click="show2 = !show2">
          <v-icon>{{ show2 ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
        </v-btn>
      </v-card-title>
      <v-expand-transition>
        <div v-show="show2">
          <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <!-- {{ mvp }} -->
              <v-row class="pa-4" v-if="mvp">
                <v-col
                  v-for="(mv, index) in mvp.MVP"
                  :key="index"
                  align="center"
                  justify="center"
                >
                  <v-card class="mx-auto rounded-lg" elevation="4">
                    <p class="pt-3 text-caption text-sm-h6">
                      {{ mv.company }} MVP
                    </p>
                    <v-card-text
                      class="text-h4 font-weight-bold light-blue--text"
                    >
                      <v-img
                        height="100"
                        width="100"
                        :src="mv.fotoUrl"
                        class="rounded-circle text-center mb-3"
                      ></v-img>
                      {{ mv.digits }}
                    </v-card-text>
                  </v-card>
                </v-col>
                <!-- <v-col>
        <v-card class="mx-auto rounded-lg" height="170" elevation="4">
          <p class="px-3 pt-3 text-caption text-sm-h6">HRK MVP</p>
          <v-card-text class="text-h2 font-weight-bold light-blue--text">
            NYA
          </v-card-text>
        </v-card>
      </v-col>
      <v-col>
        <v-card class="mx-auto rounded-lg" height="170" elevation="4">
          <p class="px-3 pt-3 text-caption text-sm-h6">NTX MVP</p>
          <v-card-text class="text-h2 font-weight-bold light-blue--text">
            ADA
          </v-card-text>
        </v-card>
      </v-col>
      <v-col>
        <v-card class="mx-auto rounded-lg" height="170" elevation="4">
          <p class="px-3 pt-3 text-caption text-sm-h6">ISI Support MVP</p>
          <v-card-text class="text-h2 font-weight-bold light-blue--text">
            DEH
          </v-card-text>
        </v-card>
      </v-col> -->
              </v-row>
            </v-container>
          </v-card-text>
        </div>
      </v-expand-transition>
    </v-card>
    <v-card class="mx-auto">
      <v-card-title>
        Data
        <v-spacer></v-spacer>

        <v-btn icon @click="show1 = !show1">
          <v-icon>{{ show ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
        </v-btn>
      </v-card-title>
      <v-expand-transition>
        <div v-show="show1">
          <v-divider></v-divider>
          <v-card-text>
            <v-container v-if="mvp">
              <v-row>
                <v-col>
                  <highcharts :options="chartOptionsNTX"></highcharts>
                </v-col>
                <v-col>
                  <highcharts :options="chartOptionsHRK"></highcharts>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <highcharts :options="chartOptionsISI"></highcharts>
                </v-col>
                <v-col>
                  <highcharts :options="chartOptionsSUP"></highcharts> </v-col
              ></v-row>
              <!-- {{chartOptionsNTX}} -->
            </v-container>
          </v-card-text>
        </div>
      </v-expand-transition>
    </v-card>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";
export default {
  components: {
    highcharts: Chart,
  },
  data() {
    return {
      show: false,
      show1: false,
      show2: false,
      mvp: null,
      chartOptions: {
        chart: {
          type: "bar",
        },
        title: {
          text: "",
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          min: 0,
        },
        legend: {
          reversed: true,
        },
        plotOptions: {
          series: {
            stacking: "normal",
          },
        },
        series: [
          {
            name: "Average Value",
            data: [],
          },
        ],
      },
      chartOptionsNTX: {
        chart: {
          type: "bar",
        },
        title: {
          text: "MVP NTX",
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          min: 0,
        },
        legend: {
          reversed: true,
        },
        plotOptions: {
          series: {
            stacking: "normal",
          },
        },
        series: [
          {
            name: "Vote",
            data: [],
          },
        ],
      },
      chartOptionsHRK: {
        chart: {
          type: "bar",
        },
        title: {
          text: "MVP HRK",
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          min: 0,
        },
        legend: {
          reversed: true,
        },
        plotOptions: {
          series: {
            stacking: "normal",
          },
        },
        series: [
          {
            name: "Vote",
            data: [],
          },
        ],
      },
      chartOptionsSUP: {
        chart: {
          type: "bar",
        },
        title: {
          text: "MVP Support",
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          min: 0,
        },
        legend: {
          reversed: true,
        },
        plotOptions: {
          series: {
            stacking: "normal",
          },
        },
        series: [
          {
            name: "Vote",
            data: [],
          },
        ],
      },
      chartOptionsISI: {
        chart: {
          type: "bar",
        },
        title: {
          text: "MVP ISI",
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          min: 0,
        },
        legend: {
          reversed: true,
        },
        plotOptions: {
          series: {
            stacking: "normal",
          },
        },
        series: [
          {
            name: "Vote",
            data: [],
          },
        ],
      },
    };
  },
  mounted() {
    this.getQuest();
    this.getMVP();
    this.getSurveys();

    // console.log(this.mvp);
  },
  methods: {
    getQuest() {
      this.axios
        .get(`${process.env.VUE_APP_API}/api/questions`)
        .then((response) => {
          const payload = response.data;
          this.surveys = payload.data;
          this.surveys.forEach((element) => {
            this.chartOptions.xAxis.categories.push(element.question);
          });
        });
    },
    getSurveys() {
      this.axios
        .get(`${process.env.VUE_APP_API}/api/surveys`)
        .then((response) => {
          const payload = response.data;
          // console.log(payload.data, "<< SURVEYS");
          // this.surveys = payload.data;
          this.chartOptions.series[0].data = payload.data;
        });
    },
    getMVP() {
      this.axios
        .get(`${process.env.VUE_APP_API}/api/best-employees`)
        .then((response) => {
          const payload = response.data;
          // console.log(payload.data, "< BEST EMPLO");
          this.mvp = payload.data;
          this.mvp.NTX.data.forEach((element) => {
            this.chartOptionsNTX.series[0].data.push(parseInt(element));
          });
          this.mvp.HRK.data.forEach((element) => {
            this.chartOptionsHRK.series[0].data.push(parseInt(element));
          });
          this.mvp.SUPPORT.data.forEach((element) => {
            this.chartOptionsSUP.series[0].data.push(parseInt(element));
          });
          this.mvp.ISI.data.forEach((element) => {
            this.chartOptionsISI.series[0].data.push(parseInt(element));
          });
          this.chartOptionsNTX.xAxis.categories = this.mvp.NTX.digits;
          this.chartOptionsHRK.xAxis.categories = this.mvp.HRK.digits;
          this.chartOptionsISI.xAxis.categories = this.mvp.ISI.digits;
          this.chartOptionsSUP.xAxis.categories = this.mvp.SUPPORT.digits;
          // console.log('asasas',this.chartOptionsNTX.xAxis.categories);
        });
    },
    getAllData() {
      this.getQuest();
      this.getSurveys();
      this.chartOptionsHRK.series[0].data = [];
      this.chartOptionsNTX.series[0].data = [];
      this.chartOptionsISI.series[0].data = [];
      this.chartOptionsSUP.series[0].data = [];
      this.chartOptionsNTX.xAxis.categories = [];
      this.chartOptionsHRK.xAxis.categories = [];
      this.chartOptionsISI.xAxis.categories = [];
      this.chartOptionsSUP.xAxis.categories = [];
      this.getMVP();
    },
  },
  watch: {
    mvp(newVal) {
      // console.log(newVal.ISI);
    },
  },
};
</script>
